type Stage = 'local' | 'dev' | 'prod';

const stage = (process.env.STAGE as Stage) || 'local';
const domain = process.env.DOMAIN || 'http://localhost:3001';
const version = process.env.VERSION || 'v1';

type Config = {
  version: string;
  domain: string;
  stage: string;
  rootDomain: string;
  isProduction: boolean;
  paymentPageUrl: string;
  posPaymentPageUrl: string;
  cardInputUrl: string;
  paymentModalUrl: string;
  bizumUrl: string;
  bizumButtonUrl: string;
  cofidisUrl: string;
  cofidisButtonUrl: string;
  cofidisWidgetUrl: string;
  cofidisLoanUrl: string;
  cofidisLoanButtonUrl: string;
  cofidisLoanWidgetUrl: string;
  paypalUrl: string;
  apiUrl: string;
  googlePayUrl: string;
  paymentRequestUrl: string;
  secureDomain: string;
  click2PayUrl: string;
  click2PayButtonUrl: string;
};

const globalConfig = {
  domain,
  version,
  stage,
  isProduction: stage === 'prod',
  paymentPageUrl: `${domain}/${version}/payment-page/`,
  posPaymentPageUrl: `${domain}/${version}/pos-payment-page/`,
  cardInputUrl: `${domain}/${version}/inner-card-input/`,
  paymentModalUrl: `${domain}/${version}/inner-payment-modal/`,
  paypalUrl: `${domain}/${version}/inner-paypal/`,
  bizumUrl: `${domain}/${version}/inner-bizum/`,
  bizumButtonUrl: `${domain}/${version}/inner-bizum-button/`,
  cofidisUrl: `${domain}/${version}/inner-cofidis/`,
  cofidisButtonUrl: `${domain}/${version}/inner-cofidis-button/`,
  cofidisWidgetUrl: `${domain}/${version}/inner-cofidis-widget/`,
  cofidisLoanUrl: `${domain}/${version}/inner-cofidis-loan/`,
  cofidisLoanButtonUrl: `${domain}/${version}/inner-cofidis-loan-button/`,
  cofidisLoanWidgetUrl: `${domain}/${version}/inner-cofidis-loan-widget/`,
  googlePayUrl: `${domain}/${version}/inner-google-pay/`,
  paymentRequestUrl: `${domain}/${version}/inner-payment-request/`,
  click2PayUrl: `${domain}/${version}/inner-click2pay/`,
  click2PayButtonUrl: `${domain}/${version}/inner-click2pay-button/`
};

const stageConfig = {
  local: {
    paymentPageUrl: `http://localhost:8080/`,
    posPaymentPageUrl: `http://localhost:8080/`,
    cardInputUrl: `http://localhost:3001/${version}/inner-card-input/`,
    paymentModalUrl: `http://localhost:3002/${version}/inner-payment-modal/`,
    paypalUrl: `http://localhost:3003/${version}/inner-paypal/`,
    bizumUrl: `http://localhost:3004/${version}/inner-bizum/`,
    bizumButtonUrl: `http://localhost:3005/${version}/inner-bizum-button/`,
    googlePayUrl: `http://localhost:3006/${version}/inner-google-pay/`,
    paymentRequestUrl: `https://monei-local.ngrok.io/${version}/inner-payment-request/`,
    click2PayUrl: `http://localhost:3008/inner-click2pay/`,
    click2PayButtonUrl: `http://localhost:3009/inner-click2pay-button/`,
    cofidisUrl: `http://localhost:3010/${version}/inner-cofidis/`,
    cofidisButtonUrl: `http://localhost:3011/${version}/inner-cofidis-button/`,
    cofidisWidgetUrl: `http://localhost:3012/${version}/inner-cofidis-widget/`,
    cofidisLoanUrl: `http://localhost:3013/${version}/inner-cofidis-loan/`,
    cofidisLoanButtonUrl: `http://localhost:3014/${version}/inner-cofidis-loan-button/`,
    cofidisLoanWidgetUrl: `http://localhost:3015/${version}/inner-cofidis-loan-widget/`,
    apiUrl: 'https://api.monei.com/v1',
    secureDomain: 'https://secure.monei.com',
    rootDomain: 'monei.com'
  },
  dev: {
    apiUrl: 'https://api.microapps-staging.com/v1',
    secureDomain: 'https://secure.microapps-staging.com',
    rootDomain: 'microapps-staging.com'
  },
  prod: {
    apiUrl: 'https://api.monei.com/v1',
    secureDomain: 'https://secure.monei.com',
    rootDomain: 'monei.com'
  }
};

export const config = {...globalConfig, ...stageConfig[stage]} as Config;
